const scrollTrigger = document.querySelectorAll('.js-scroll-trigger');

scrollTrigger.forEach((elem) => {
	ScrollTrigger.create({
	  trigger: elem,
	  start: "top bottom",
	  end: "bottom top",
	  toggleClass: { targets: elem, className: "active" },
	  markers: false
	});
  });

const heroReveal = document.querySelectorAll('.js-hero-reveal');

  heroReveal.forEach((elem) => {
	
	ScrollTrigger.create({
	  trigger: elem,
	  pin: true,
	  start: "top top",
	  end: "bottom top",
	  pinSpacing: false,
	  markers: false
	});
  });

  let dragIndicator = document.querySelector('.js-drag-indicator');

  // Variables to store the target positions.
  let targetX = 0;
  let targetY = 0;
  
  // Update target positions on mouse move.
  document.addEventListener('mousemove', (e) => {
	targetX = e.clientX;
	targetY = e.clientY;
  });
  
  // On each GSAP tick, smoothly move the indicator toward the target.
  gsap.ticker.add(() => {
	gsap.to(dragIndicator, {
	  top: targetY,
	  left: targetX,
	  duration: 0,       // Adjust this for more or less lag
	  ease: "power3.out"   // Adjust easing as desired
	});
  });

const playableVideo = document.querySelectorAll('.js-playable-video');

playableVideo.forEach((elem) => {

	let video = elem.querySelector('video');

	video.addEventListener('click', () => {
		if (video.paused) {
			video.play();
		} else {
			video.pause();
		}
	});


	elem.addEventListener('mouseenter', () => {
		gsap.to(dragIndicator, { scale: 2.5, duration: 0.4 });
	});
	elem.addEventListener('mouseleave', () => {
		gsap.to(dragIndicator, { scale: 1, duration: 0.4 });
	});
  });